import { type DefaultTheme, styled } from 'styled-components';

type Props = {
  disabled: boolean;
  checked: boolean;
};

const Container = styled.span<Props>`
  display: inline-block;
  vertical-align: middle;
  position: relative;
  width: ${({ theme }) => theme.designTokens.radioSize};
  height: ${({ theme }) => theme.designTokens.radioSize};
  border-radius: 50%;
  &:focus,
  &.focus {
    outline: none;
    box-shadow: ${({ theme }) => theme.designTokens.radioFocusShadow};
  }
`;

const getRadioColor = ({ theme, checked, disabled }: Props & { theme: DefaultTheme }) => {
  if (checked && disabled) return theme.designTokens.radioCheckedDisabledColor;
  else if (checked) return theme.designTokens.radioCheckedColor;
  else if (disabled) return theme.designTokens.radioDisabledColor;
  else return theme.designTokens.radioColor;
};

const OuterCircle = styled.span<Props>`
  display: block;
  border-radius: 50%;
  height: 100%;
  box-sizing: border-box;
  border-style: solid;
  border-width: ${({ theme, checked }) =>
    checked ? theme.designTokens.radioCheckedBorderWidth : theme.designTokens.radioBorderWidth};
  border-color: ${getRadioColor};
  background: transparent;
`;
const InnerCircle = styled.span<Props>`
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  height: ${({ theme }) => theme.designTokens.radioInnerCircleSize};
  width: ${({ theme }) => theme.designTokens.radioInnerCircleSize};
  background: ${getRadioColor};
`;

export const Styled = {
  Container,
  OuterCircle,
  InnerCircle,
};
